import { createUseStyles } from "react-jss";

export default createUseStyles({
    panelContainer: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    title: {
        margin: 0,
        marginBottom: 10,
        fontSize: "15px",
        fontWeight: 700,
        color: "#484848",
    },
    sectionTitle: {
        margin: 0,
        marginTop: 20,
        marginBottom: 10,
        fontWeight: 700,
        fontSize: "13px",
        color: "#484848",
    },
    search: {
        background: "#F3F3F3",
        position: "relative",
        padding: [[8, 16]],
        marginBottom: 16,
        borderRadius: 30,
    },
    searchIcon: {
        color: "#A2A2A2",
    },
    searchInput: {
        width: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        border: 0,
        background: "none",
        paddingLeft: 48,
        paddingRight: 16,
        fontSize: "13px",
        outline: "none",
    },
    scrollable: {
        flex: "1",
        overflowY: "scroll",
        overflowX: "hidden",
        paddingRight: 16,
        scrollbarWidth: "18px",
        scrollbarColor: "red blue",
    },
});
